/*!

=========================================================
* Argon Dashboard React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React, { useEffect, useState, useRef } from "react";
import classnames from "classnames";
import NumberFormat from "react-number-format";
import Skeleton from 'react-loading-skeleton';
import axiosInstance from "./../../helpers/axiosInstance";
import Pdf from "react-to-pdf";
import icon_Contactos_Inscritos from 'assets/img/icons/Icono-Contactos-Inscritos-Gris.png'
import icon_Contactos_InscritosA from 'assets/img/icons/Icono-Contactos-Inscritos-Verde.png'
import icon_transferencias from 'assets/img/icons/Icono-Transferencias-Gris.png'
import icon_transferenciasA from 'assets/img/icons/Icono-Transferencias-Rojo.png'
import icon_VerTransferencias from 'assets/img/icons/Icono-Transfrencias-Multiples-Gris.png'
import icon_VerTransferenciasA from 'assets/img/icons/Icono-Transfrencias-Multiples-Verde.png'
import Compotp from "views/siif/Compotp";
import {useDispatch} from "react-redux";
import {cambiaruta,cambiasidebar,desactivasidebar} from "../../Slicersreducers";

// reactstrap components
import {
  Card,
  CardBody,
  CardTitle,
  Container,
  Row,
  Col,
  NavItem,
  NavLink,
  Nav,
  TabContent,
  TabPane,
  CardHeader,
  Button,
  FormGroup,
  InputGroup,
  Input,
  InputGroupAddon,
  InputGroupText,
  Modal,
  Spinner
} from "reactstrap";
import { normalizeUnits } from "moment";
import { set } from "date-fns";

function TransferHeader(account) {

  var tabsAux = 0;
  var accountAux = {};
  var stepAux = 0;
  if (account.account != null) {
    accountAux = account.account;
    stepAux = 1;
    tabsAux = 1;
  }

  // build ptoduct two
  let auxBuildProductTwo = {
    system: '20',
    accountNumber: '',
    tid: 1,
    nid: ''
  }
  async function getProduct(product, tab,index) {
    //product.isSelectProduct = !product.isSelectProduct;
    
    if(OpcProdSelec<0){
      setpermisosProd(permisosguardados[index]);
      setfuncionalidadHabil(3);
      await setProduct(product);
      
      if(product.maxTransaction){
        settopesxprod({
          maxTransaction:product.maxTransaction,
          maxDaily:product.maxDaily
          
        });
        /*if(topeMD==1){
          setmaxDaily(product.maxTransaction);

        }else{
          setmaxDaily(product.maxDaily);
          
        }*/

      }else{
        settopesxprod({
          maxTransaction:"",
          maxDaily:""
        });
        setmaxDaily("");

      }
      
      
      //setplacetopes("Tope Monto Transaccional");
      setOpcProdSelec(index);
    }
  }
  const [tabToGo, setTabToGo] = useState(0);

  const listStep = [{ title: "Desde" }, { title: "Valor" }, { title: "Hacia" }, { title: "Confirma" }];
  const listStep2 = [{ title: "Desde" }, { title: "Valor" }, { title: "Hacia" }, { title: "Confirma" }];

  const [tabs, setTabs] = useState(tabsAux);
  const [types, setTypes] = useState(0);
  const [transcode, setCode] = useState(0);

  const [OpcProdSelec,setOpcProdSelec]=useState(-1);
  const [permisosProd,setpermisosProd]=useState({
    maxDaily:"",
    maxTransaction:"",
    otp:false,
    supervisor:false,
    consulta:false,
    transaccion:false
  })
  const [permisosguardados,setpermisosguardados]=useState([]);
  const [funcionalidadHabil,setfuncionalidadHabil]=useState(0);
  const [product, setProduct] = useState();
  const [topesxprod,settopesxprod]=useState({
    maxTransaction:"",
    maxDaily:""
  })
  const [maxDaily,setmaxDaily]=useState("");
  
  const [cancelationModal, setCancelationModal] = useState(false);
  const [notificationModal, setNotificationModal] = useState(false);
  const [processModal, setProcessModal] = useState(false);
  const [errorModal, setErroModal] = useState(false);
  const [pendingModal, setPendingModal] = useState(false);

  const [step, setStep] = useState(stepAux);
  const [step2, setStep2] = useState(0);

  const [productOne, setProductOne] = useState(accountAux);
  const [productTwo, setProductTwo] = useState({});

  const [value, setValue] = useState("");
  const [commission, setCommission] = useState("");
  const dispatch=useDispatch()

  const [relatedAccounts, setRelatedAccounts] = useState([]);
  const [accounts, setAccounts] = useState([]);
  const [accountsToTransfer, setAccountsToTransfer] = useState([]);
  const [historicalTransfer, setHistoricalTransfer] = useState([]);

  const [nameFile, setNameFile] = useState("Selecciona el archivo");
  const [contentFiel, setContentFiel] = useState("");
  const [activeContact,setActiveContact] = useState(true);
  const [activeVertrans,setActiveVertrans] = useState(false);

  const [isLoadingAccounts, setIsLoadingAccounts] = useState(true);
  const [isLoadingHistorical, setIsLoadingHistorical] = useState(true);
  const [imagen,setImagen] = useState(icon_Contactos_InscritosA);
  const [imagenTransferencias,setImagenTransferencias] = useState(icon_transferencias);
  const [imagenVerTransferencias,setImagenVerTransferencias] = useState(icon_VerTransferencias);
  const [color,setColor] = useState("text-success");
  const [colorTransferencias,setColorTransferencias] = useState("text-gray-dark");
  const [colorVerTransferencias,setColorVerTransferencias] = useState("text-gray-dark");
  var createReactClass = require('create-react-class');  
  const ref = React.createRef();

  // temporal prueba 
  //const [ref1, setRef1]= useState("");
  //const [ref2, setRef2]= useState("");
  //const [ref3, setRef3]= useState("");
  //const [ref4, setRef4]= useState("");
  //const [ref5, setRef5]= useState("");
  //const [ref6, setRef6]= useState("");
  const ref1 = useRef(null);
  const ref2 = useRef(null);
  const ref3 = useRef(null);
  const ref4 = useRef(null);
  const ref5 = useRef(null);
  const ref6 = useRef(null)
  const [pideotp,setpideotp]=useState(false);
  const [cargaotp,setcargaotp]=useState(false);
  const [listAlert, setListAlert] = useState([]);
  
  const handleSubmit = (cadena) => {
    //e.preventDefault();
    //RequestOTPTransfer.Otp= ref1.current.value + ""+ ref2.current.value + ""+ ref3.current.value + ""+ ref4.current.value + ""+ ref5.current.value + ""+ ref6.current.value ;
    RequestOTPTransfer.Otp=cadena;
    console.log("refotp" + RequestOTPTransfer.Otp);
    if(cadena.length>0){
      setcargaotp(true);
      validOtp();

    }else{
      setpideotp(false)
    }
    
  };

  // fin temporal prueba 
  var Alerts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;
      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <div class={item.type} role="alert">
              <button
                type="button"
                class="close"
                aria-label="Close"
                onClick={() => deleteAlert(item)}
              >
                <span aria-hidden="true">×</span>
              </button>
              <span className="alert-inner--icon mr-3">
                <i className={item.icon} />
              </span>{" "}
              <span class="alert-inner--text">{item.description}</span>
            </div>
          );
        });
      }
      return <div className="toast-bottom-right">{newsTemplate}</div>;
    },
  });
  useEffect(async() => {
    
    
    const timer = setTimeout(deleteElementFromArr, 5000);
    return () => clearTimeout(timer);
  });

  const deleteElementFromArr = () => {
    
    if (listAlert.length > 0) {
      let temp = listAlert.slice();
      temp.splice(0, 1);
      setListAlert(temp);
    }
  };
  const deleteAlert = (alert) => {

    console.log("elimina alerta");
    console.log(listAlert);
    setListAlert(listAlert.filter((auxAlert) => auxAlert != alert));
  };


  var CardAccount = createReactClass({
    render: function () {
      var accountNumber = this.props.data.accountNumber,
        balance = this.props.data.balance,
        description = this.props.data.description;

      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card className="mb-xl-0 shadow cursor-pointer bordeHover">
            <CardBody className="">
              <Row>
                <div onClick={()=>getProduct(this.props.data, this.props.tab,this.props.index)} className="col-auto ml-4 p-1" style={{ width: "80%" }}>
                  <Row>
                    <span class="mb-0">{description} <br /> No. {accountNumber}</span>
                  </Row>
                  <Row>
                   <span class="mb-0 text-sm">Disponible <NumberFormat value={balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></span>
                  </Row>
                </div>
              </Row>
            </CardBody>
          </Card>
        </Col>
      );
    
  }
  });

  async function getProductOrigin(product, tab) {
    console.log("getproductorigin");
    console.log(product);
    await setProductOne(product);
    if (tab === 1) {
      await setStep(s => s + 1);
    } else if (tab === 2) {
      await setStep2(s => s + 1);
    }
    await setTabs(tab);
  }

  async function getProductDestiny(product, tab) {
    console.log("getproductdestiny");
    console.log(product)
    getCommission();
    await setProductTwo(product);
    if (tab === 1) {
      await setStep(s => s + 1);
    } else if (tab === 2) {
      await setStep2(s => s + 1);
    }
    await setTabs(tab);
  }

  async function getCommission() {
    let request = {
      operation_type: 1,
      amount: value
    }
    let auxValue = ""
    if (value.includes(".")) {
      //auxValue = value.substring(0,value.indexOf(".")).replace(/,/g, '')
      auxValue =  "" + (value.replace(/,/g, '').replace(/\./g, ''))
    }else{
     auxValue =  "" + parseFloat(value.replace(/,/g, '')*100)
    }
    const response = await axiosInstance().get("/WSGYG39_2/api/Inquiries/comissions/" + 2 + "/" + auxValue + "/" + productOne.accountNumber + "/" + productOne.system)
      .catch(err => {
        if (err.response.data.errors) {
          setListAlert(
            err.response.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "No se pudo bloquear el usuario debido a un problema.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
        }
        return 'err';

      });
      console.log("respuesta comisiones");
    console.log(response);
    if (response != 'err') {
      setCommission(response.data.cost)
    }
  }

  var Products = createReactClass({
    render: function () {
      var data = this.props.data;
      var tab = this.props.tab;
      var isOrigin = this.props.isOrigin;
      var newsTemplate;

      if ((data.length > 0)) {
        newsTemplate = data.map(function (item, index) {
          if (isOrigin) {
            if(item.balance != 0){
            return (
              <Row key={index} onClick={() => getProductOrigin(item, tab)}>
                <CardAccount data={item} />
              </Row>
            )}
          } else {
            return (
              <Row key={index} onClick={() => getProductDestiny(item, tab)}>
                <CardAccount data={item} />
              </Row>
            )
          }
        })
      } else {
        newsTemplate = <Skeleton height={100} count={4} className="card-transaction-info" style={{ width: "-webkit-fill-available" }}></Skeleton>
      }
      return (
        <div>
          {newsTemplate}
        </div>
      );
    }
  });


  var CardAccountContact = createReactClass({
    render: function () {
      var aliasAccount = this.props.data.aliasAccount,
        numeroCuenta = this.props.data.numeroCuenta;
      return (
        <Col lg="12" xl="12" className="pt-3">
          <Card className="mb-xl-0 cursor-pointer bordeHover">
          <CardBody className="">
            <div className="">
              <Row>
                {/* <div className="col-auto vertical-center">
                  <Row className="m-4">
                    <i className="fas fa-money-bill text-primary" />
                  </Row>
                </div> */}
                <div className="col ml-4">
                  <Row>
                    <span class="mt-1 text-sm h4">{aliasAccount}</span>
                  </Row>
                  <Row>
                    <span class="mt-0 mb-0 text-sm">Cuenta No. {numeroCuenta}</span>
                  </Row>
                  <Row>
                    <span class="mb-1 text-sm"></span>
                  </Row>
                </div>
                {/* <div className="col-auto mr-3 vertical-center">
                  <Row className="m-4">
                    <a className="button"><i className="fas fa-chevron-right" /></a>
                  </Row>
                </div> */}
              </Row>
            </div>
            </CardBody>
          </Card>
        </Col>
      );
    }
  });

  async function getContact(product) {
    getCommission();
    await setProductTwo(product);
    await setStep(s => s + 1);
  }

  async function goBack(tab, isFirst) {
    if (!isFirst) {
      if (tab === 1) {
        await setStep(s => s - 1);
      } else if (tab === 2) {
        await setStep2(s => s - 1);
      }
    } else {
      setCancelationModal(true);
      await setTabToGo(0);
    }
  }

  var RelatedAccounts = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;

      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <Row key={index} onClick={() => getContact(item)}>
              <CardAccountContact data={item} />
            </Row>
          )
        })
      } else if (isLoadingAccounts) {
        newsTemplate = <Skeleton height={100} count={4} className="card-transaction-info" style={{ width: "-webkit-fill-available" }}></Skeleton>
      } else {
        newsTemplate = <div className="text-center m-4">
          <h2 class="ml-2"> No cuentas con Cuentas Asociadas </h2>
        </div>;
      }
      return (
        <div>
          {newsTemplate}
        </div>
      );
    }
  });

  var HistoricalTransfers = createReactClass({
    render: function () {
      var data = this.props.data;
      var newsTemplate;

      if (data.length > 0) {
        newsTemplate = data.map(function (item, index) {
          return (
            <CardHistoricalTransfer key={index}  data={item} />
          )
        }) 
      } else if (isLoadingHistorical) {
        newsTemplate = <Skeleton height={150} count={3} className="card-transaction-info" style={{ width: "-webkit-fill-available" }}></Skeleton>
      } else {
        newsTemplate = <div className="text-center m-4">
          <h2 class="ml-2"> No se encuentran transacciones en el historial. </h2>
        </div>;
      }
      return (
        <div className="col-md-12 p-2" style={{ justifyContent: "space-between" }}>
          {newsTemplate}
        </div>
      );
    }
  });

  var CardHistoricalTransfer = createReactClass({
    render: function () {
      var nut = this.props.data.nut,
      product_Number = this.props.data.product_Number,
      transaction_Value = this.props.data.transaction_Value,
      transaction_Status = this.props.data.transaction_Status,
      date_Transaction = this.props.data.date_Transaction,
      year = this.props.data.date_Transaction.substring(0,3),
      month = this.props.data.date_Transaction.substring(5,6),
      day = this.props.data.date_Transaction.substring(8,9),
      last_Update_Time = this.props.data.last_Update_Time;
      return (
        <div className="shadow" style={{ padding: "10px 15px 0", marginBottom: 16 + 'px', display: "flex", justifyContent: "space-between", flexDirection: "column", position: "relative", padding: 15 + 'px', minHeight: 80 + 'px', borderRadius: 15 + 'px', boxShadow: "0 2px 4px 0 rgb(65 74 83 / 30%)", backgroundColor: "#fff", width: 100 + '%' }}>
          <div style={{ position: "absolute", width: 16 + 'px', height: 16 + 'px', left: 10 + 'px', top: 16 + 'px' }}>
            <i class="fas fa-exchange-alt"></i>
          </div>
          <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-start" }}>
            <p class="mb-2 ml-4" style={{ fontSize: 12 + 'px' }}><span style={{ fontSize: 12 + 'px', fontWeight: 400, color: "#77899a" }}> {date_Transaction} a las {last_Update_Time} </span> - Transferencia de Cuenta Santander </p>
            <p class="mb-2 ml-4" style={{ fontSize: 12 + 'px', fontWeight: 400, }}> Ahorros No. {product_Number} </p>
            <p class="mb-2 ml-4" style={{ fontSize: 12 + 'px', fontWeight: 400, }}> Numero de Transacción {nut} </p>
            <p class="mb-2 ml-4" style={{ fontSize: 12 + 'px', fontWeight: 400, }}> Estado de la Transacción: {transaction_Status} </p>
            <p class="mb-2 ml-4" style={{ fontSize: 1 + 'rem', fontWeight: 700, }}> <NumberFormat value={transaction_Value} displayType={'text'} thousandSeparator={true} prefix={'$'} /> </p>
          </div>
        </div>
      );
    }
  });

  async function getTypeAccount(type) {
    await setTypes(type);
  }

  function DivStep({ children }) {
    return <>{children}</>
  }

  function Progress(props) {
    const styleProgress = { width: ((100/props.list.length)-2) + '%' };
    var newsTemplate = props.list.map(function (item, index) {
      if (index === props.current) {
        return <div key={index} className="progress-bar-step-active" style={styleProgress}>
          <span className="stepper-number-active">
            <span className="stepper-label-active">{index + 1}</span>
          </span>
        </div>;
      } else {
        return <div key={index} className="progress-bar-step" style={styleProgress}>
          <span className="stepper-number">
            <span className="stepper-label">{index + 1}</span>
          </span>
        </div>;
      }
    });
    return newsTemplate;
  }

  function LineStepper(props) {
    return (
      <>
        <div style={{ position: "relative"}} className="mt-1 m-4 mb-6">
          <div style={{ position: "absolute", width: '100%'}}>
            <Progress
              current={props.current}
              list={props.listStep}
            ></Progress>
            </div>
        </div>
      </>
    );
  }


  function NavigationButtons(props) {
    var isFirst = props.step === 0;
    return (
      <div style={{ justifyContent: "space-between", display: "flex" }}>
        <button class="btn-icon text-gray-dark btn" onClick={() => goBack(props.tab, isFirst)}>
        <span class="btn-inner--icon">{"<"}</span>
        <span class="btn-inner--text">Volver</span>
        </button>
        <button class="btn-icon text-gray-dark btn" disabled={isFirst} onClick={() => setCancelationModal(true)}>
          <span class="btn-inner--text">Cancelar</span>
          <span class="btn-inner--icon">
            <i class="fas fa-times"></i>
          </span>
        </button>
      </div>
    );
  };

  function DivStepper({ children, ...props }) {
    const childrenArray = React.Children.toArray(children);

    const currentChild = childrenArray[props.step];
    if (props.step != childrenArray.length - 1) {
      return (
        <div {...props}>
          <NavigationButtons tab={props.tab} step={props.step}></NavigationButtons>
          <LineStepper current={props.step} listStep={props.listStep}></LineStepper>
          {currentChild}
        </div>
      );
    } else {
      return (
        <div {...props}>
          <NavigationButtons tab={props.tab} step={props.step}></NavigationButtons>
          <LineStepper current={props.step} listStep={props.listStep}></LineStepper>
          {currentChild}
        </div>
      );
    }
  }

  useEffect(() => {
    console.log("useeffect transfers" )
    console.log(account)
    async function getProducts() {
      const request = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Products/Accounts")
        .catch(err => {
          if (err.response.data.errors) {
            setListAlert(
              err.response.data.errors.map((o) => ({
                ...o,
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle",
              }))
            );
          } else {
            setListAlert([
              {
                description: "No se pudo bloquear el usuario debido a un problema.",
                type: "alert alert-alert show alert-dismissible fade alert-danger",
                icon: "fas fa-exclamation-circle"
              }
            ]);
          }
          return 'err';
        });
        console.log("respuesta account");
      console.log(request)
      if (request != 'err') {
        console.log(request.data);
        console.log(request.data.summaryProduct.product);
        setAccounts(request.data.summaryProduct.product);
      }
      return request;
    }
    getProducts();
    //this.toggleNavs(this.e, "tabs", 1)
  }, []);

  async function getRelatedAccounts() {
    setIsLoadingAccounts(true);
    await setStep(s => s + 1);
    const request = await axiosInstance().get("/WSGYG39_2/api/Consultas/AssociatedAccounts")
      .catch(err => {
        if (err.response.data.errors) {
          setListAlert(
            err.response.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "No se pudo bloquear el usuario debido a un problema.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
        }
        setIsLoadingAccounts(false);
        return 'err';
      });
      console.log("respuesta cuentas asociadas");
      console.log(request)
    if (request != 'err') {
      setIsLoadingAccounts(false);
      console.log(request.data);
      setRelatedAccounts(request.data.relatedAccounts.filter(item => (item.status === null)));
    }
    setAccountsToTransfer(accounts.filter(item => !(item.accountNumber === productOne.accountNumber)))
    return request;
  }

  async function validOtp() {
    RequestOTPTransfer.IdTransfer=transcode;
    //console.log("ref1:" + ref1);
    //RequestOTPTransfer.Otp=
    //ref1 +""+ ref2+""+ ref3+""+ ref4+""+ ref5+""+ ref6+"";
    let codigoSR05012=false;
    console.log("valido " + RequestOTPTransfer.Otp)
    const request = await axiosInstance().post("/WSGYG39_2/api/Transaction/ValidOtp",RequestOTPTransfer)
      .catch(err => {
        
        if (err.response.data.errors) {
          setListAlert(
            err.response.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            }))
          );
          err.response.data.errors.map((o)=>{
            if(o.code=="SR05012"){
              codigoSR05012=true;
            }})
        } else {
          codigoSR05012=true;
          setListAlert([
            {
              description: "No se pudo bloquear el usuario debido a un problema.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
        }
        console.log("Error del consumo valida otp")
        return 'err';
      });
      console.log("respuesta valida otp");
      console.log(request);
    if (request != 'err') {      
      console.log("respuesta : " + request.data.plot);
      //setNotificationModal(true)  ;// modal para ingresar el otp 
      setNotificationModal(false);
      setProcessModal(true);//confirmacion exitosa transacccion.
      setTabs(0); // reiniciar pasos 
      setStep(0);
      setStep2(0);
      setpideotp(false);
      setcargaotp(false);
    } else {  
      // 
      //console.log("respuesta indicador : " + request.data.page);
      if(codigoSR05012){
        setProcessModal(false);
        setNotificationModal(false);
        setErroModal(true);
        setTabs(0);
        setStep(0);
        setStep2(0);
        setpideotp(false);
        setcargaotp(false);
      }    
      setcargaotp(false);
    
    }
  }

  async function getHistoricalTransfer() {
    setIsLoadingHistorical(true);
    const request = await axiosInstance().get("/WSGYG39_2/api/Inquiries/Transactions/Accounts")
      .catch(err => {
        if (err.response.data.errors) {
          setListAlert(
            err.response.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "No se pudo bloquear el usuario debido a un problema.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
        }
        setIsLoadingHistorical(false);
        return 'err';
      });
      console.log("respuesta Accounts");
      console.log(request);
    if (request != 'err') {
      setIsLoadingHistorical(false);
      console.log(request.data);
      setHistoricalTransfer(request.data);
    }
    return request;
  }

  const valueChange = event => {
    event.preventDefault();
    let val = event.target.value;
    let auxVal1 = ""
    let auxVal2 = ""
    
    
    if (val.includes(".") ) {
      auxVal2 = val.substring(val.indexOf("."))
    
      auxVal1 = val.substring(0,val.indexOf("."))
      if(auxVal2.length > 3){
        auxVal2 = auxVal2.substring(0,3);
      }
      console.log(auxVal1);
      console.log(auxVal2);
      auxVal1 = auxVal1.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      setValue(auxVal1 + auxVal2);
    }else{
      auxVal1 = val.replace(/\D/g, "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
      setValue(auxVal1);
    }
  }

  const ProductTwoChange = event => {
    auxBuildProductTwo.accountNumber = event.target.value;
  }

  const NIDChange = event => {
    auxBuildProductTwo.nid = event.target.value;
  }

  const TIDChange = event => {
    auxBuildProductTwo.tid = event.target.value;
  }

  async function BuildAccount() {
    getCommission();
    await setProductTwo(auxBuildProductTwo);
    setStep2(s => s + 1)
  }

  const [RequestOTPTransfer, setRequestOTPTransfer] = useState({
    IdTransfer:"",    
    Otp:""
  });

  async function ShowFile() {
    if (window.File && window.FileReader && window.FileList && window.Blob) {
      var preview = document.getElementById('show-text');
      var file = document.querySelector('input[type=file]').files[0];
      console.log("name file");
      console.log(file);

      setNameFile(file.name);

      var reader = new FileReader()

      var textFile = /text.*/;

      if (file.type.match(textFile)) {
        reader.onload = function (event) {
          console.log(event.target);
          setContentFiel(event.target.result);
          preview.innerHTML = event.target.result;
        }
      } else {
        preview.innerHTML = "<span class='error'>It doesn't seem to be a text file!</span>";
      }
      reader.readAsText(file);

    } else {
      alert("Your browser is too old to support HTML5 File API");
    }
  }

  const transfer = async event => {
    setNotificationModal(false);
    var today = new Date();
    var dd = today.getDate();
    var mm = today.getMonth() + 1;
    var yyyy = today.getFullYear();
    if (dd < 10) {
      dd = '0' + dd;
    }
    if (mm < 10) {
      mm = '0' + mm;
    }
    today = yyyy + '' + mm + '' + dd;
  
    var auxValue = "";
    var system = (productTwo.tipoCuenta === 1) ? '20' : (productTwo.tipoCuenta === 2) ? '30' : '20';
    console.log("Value: " + value)
    if (value.includes(".")) {
    
      auxValue =  "" + (value.replace(/,/g, '').replace(/\./g, ''))
    }else{
     auxValue =  "" + parseFloat(value.replace(/,/g, '')) * 100
    }
  
    const consulta = {
      AccountNumber: productOne.accountNumber,
      BankCode  : (productTwo.bankCode === undefined) ? "" : productTwo.bankCode,
      Parameters: [
        productOne.accountNumber,
        productOne.system,
        ((productTwo.numeroCuenta === undefined) ? productTwo.accountNumber : productTwo.numeroCuenta),
        system,
        (productTwo.sequence === undefined) ? "" : productTwo.sequence,
        "NN090D",
        productOne.accountNumber,
        ((productTwo.numeroCuenta === undefined) ? productTwo.accountNumber : productTwo.numeroCuenta),
        today,
        auxValue
      ]
    }

    let codigoSR05011=false;
    const request = await axiosInstance().post("/WSGYG39_2/api/transaction/Transfer/Accounts", consulta)
      .catch(err => {
        if (err.response.data.errors) {
          setListAlert(
            err.response.data.errors.map((o) => ({
              ...o,
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle",
            }))
          );
        } else {
          setListAlert([
            {
              description: "No se pudo bloquear el usuario debido a un problema.",
              type: "alert alert-alert show alert-dismissible fade alert-danger",
              icon: "fas fa-exclamation-circle"
            }
          ]);
        }
        err.response.data.errors.map((o)=>{
          if(o.code=="SR05011"){
            codigoSR05011=true;// pendiente por autorizar
          }})
        return err.response;
      });
     
      
    if (request.data.page != 'ERROR' && request.data.page != undefined ) {
      var data=  request.data.plot;
      var pos = request.data.plot.toString().indexOf(",");      
      if (pos>-1 )
      {
        data= data.toString().substr(0,pos);
      }
      console.log("respuesta : " + request.data.plot);      
      await setCode(data);            
      console.log("codigo en estado: " + transcode);
      setNotificationModal(true)  ;// modal para ingresar el otp 
      //setProcessModal(true);//confirmacion exitosa transacccion.
      /*setTabs(0); // reiniciar pasos 
      setStep(0);
      setStep2(0);*/
      setpideotp(true);
    } else {  
      // 
      
      console.log("respuesta indicador : " + request.data.page);
      
      if (codigoSR05011)//pendiente por autorizar
      {
        setNotificationModal(false);
        setPendingModal(true);
      }
      else //error
      {
        setErroModal(true);
      }
      setTabs(0);
      setStep(0);
      setStep2(0);
    }
  }
  const ejecutasalirPending=()=>{
    setPendingModal(false);
  }
  const ejecutasalir=()=>{
    setCancelationModal(false);
  }
  const ejecutasalirErrorModal=()=>{
    setErroModal(false);
  }
  useEffect(() => {
    dispatch(cambiaruta("Inicio/Transferencias/A contactos inscritos"));
    dispatch(cambiasidebar(false));
    dispatch(desactivasidebar());
  }, [])
  class NavsTransfer extends React.Component {

    toggleModal = state => {
      setNotificationModal(!notificationModal);
    };
    toggleNavs = (e, state, index) => {
      e.preventDefault();
      console.log("este es el index " + index);
      if (index == 1) { 
          setActiveContact(true)
          setActiveVertrans(false)
          dispatch(cambiaruta("Inicio/Transferencias/A Contactos Inscritos"))
          setImagen(icon_Contactos_InscritosA);
          setColor("text-success");
          setImagenTransferencias(icon_transferencias);
          setColorTransferencias("text-gray-dark");
          setImagenVerTransferencias(icon_VerTransferencias);
          setColorVerTransferencias("text-gray-dark")
          
      }else if (index == 4) {
          setActiveVertrans(true)
          setActiveContact(false)
          dispatch(cambiaruta("Inicio/Transferencias/Ver Transferencias"))
          setImagenVerTransferencias(icon_VerTransferenciasA);
          setColorVerTransferencias("text-success");
          setImagen(icon_Contactos_Inscritos);
          setColor("text-gray-dark");
          setImagenTransferencias(icon_transferencias);
          setColorTransferencias("text-gray-dark");
          
      } else {
          dispatch(cambiaruta("Inicio/Transferencias/A Contactos Inscritos"))
          setActiveVertrans(false)
          setActiveContact(true)
          setImagen(icon_Contactos_InscritosA)
          setImagenTransferencias(icon_transferencias)
          setImagenVerTransferencias(icon_VerTransferencias)
          setColor("text-gray-dark")
          setColorTransferencias("text-gray-dark")
          setColorVerTransferencias("text-gray-dark")
      }
      // switch (index) {
      //   case 1:
      //     setImagen(icon_Contactos_InscritosA)
      //     setColor("text-primary")
      //     setImagenTransferencias(icon_transferencias)
      //     setColorTransferencias("text-gray-dark")
      //     setImagenVerTransferencias(icon_VerTransferencias)
      //     setColorVerTransferencias("text-gray-dark")
      //     break;
      //   case 2:
      //     setImagenTransferencias(icon_transferenciasA)
      //     setColorTransferencias("text-primary")
      //     setImagen(icon_Contactos_Inscritos)
      //     setColor("text-gray-dark")
      //     setImagenVerTransferencias(icon_VerTransferencias)
      //     setColorVerTransferencias("text-gray-dark")
      //     break;
      //   case 4:
      //     setImagenVerTransferencias(icon_VerTransferenciasA)
      //     setColorVerTransferencias("text-primary")
      //     setImagen(icon_Contactos_Inscritos)
      //     setColor("text-gray-dark")
      //     setImagenTransferencias(icon_transferencias)
      //     setColorTransferencias("text-gray-dark")
      //     break;
      //   default:
      //     setImagen(icon_Contactos_Inscritos)
      //     setImagenTransferencias(icon_transferencias)
      //     setImagenVerTransferencias(icon_VerTransferencias)
      //     setColor("text-gray-dark")
      //     break;
      // }
      setTabs(index);
    };

    render() {
      return (
        <>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={cancelationModal}
            toggle={() => setCancelationModal(!cancelationModal)}
          >
            <div className="p-4">
            <div onClick={ejecutasalir} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
              <div class="my-modal-header">
                <img alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Cancel.png").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">¿Quieres salir de la transacción?</h5>
                  <p class="header-subtitle">La información que has ingresado hasta el momento se borrará.</p>
                </div>
              </div>
              <div class="my-modal-footer pt-2">
                <button class="btn bg-white text-success shadow" type="button" onClick={() => setCancelationModal(false)}> No, volver </button>
                <button class="my-btn btn bg-success text-white shadow" type="button" onClick={() => { 
                   setTabs(tabToGo);
                   setCancelationModal(false);
                   setStep(0); setStep2(0); setTabToGo(0)}}> SÍ, SALIR </button>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={errorModal}
            toggle={() => setErroModal(!errorModal)}
          >
            <div className="p-4">
            <div onClick={ejecutasalirErrorModal} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
              <div class="my-modal-header">
                <img alt="delete-icon" style={{width:"40%"}} class="my-header-image" src={require("../../assets/img/illustrations/error-transaction.svg").default} />
                <div class="header-title">
                  <h5 class="avv-title-bold">La transacción no se pudo realizar</h5>
                  <p class="header-subtitle">Por algun motivo la transacción no se pudo realizar intentelo mas tarde.</p>
                </div>
              </div>
            </div>
          </Modal>
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={pendingModal}
            toggle={() => setPendingModal(!pendingModal)}
          >
            <div className="p-4">
            <div onClick={ejecutasalirPending} style={{width:"100%",display:"flex", justifyContent:"flex-end",alignItems:"center",cursor: "pointer"}}>
                                    <h1 style={{margin:"-15px -10px 0px 0px",fontSize:"20px"}}>
                                        <span aria-hidden={true} style={{fontSize:1.5 + 'rem'}}>
                                          <img
                                            className=""
                                            src={
                                                require("../../assets/img/icons/BD120-error _ SYMBOLS, error, close, exit, no, delete, clear, eliminar, borrar, fail, fallo-Verde.png").default
                                            }/>
                                            </span></h1>
                                </div>
              <div class="my-modal-header">                
                <img style={{height:"100px", width:"100px"}} alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/success-transfer.svg").default} />
                <div class="header-title">
                  <h4 class="avv-title-bold">La transacción se encuentra pendiente por autorizar</h4>
                  <p class="header-subtitle" style={{fontSize:"15px"}}>Comuniquese con el supervisor para autorizar transacción.</p>
                </div>
              </div>
            </div>
          </Modal>
          <Compotp esperando={cargaotp} pideotp={pideotp} funcrespadre={handleSubmit} mensaje={"Verifica la transferencia con el numero que se envio a tu celular."}></Compotp>
          <Alerts data={listAlert}></Alerts>
          {/*
          <Modal
            className="modal-dialog-centered"
            contentClassName=""
            isOpen={notificationModal}
            toggle={() => this.toggleModal("notificationModal")}
          >
            <div className="modal-header">
              <button
                aria-label="Close"
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => this.toggleModal("notificationModal")}
              >
                <span aria-hidden={true}>×</span>
              </button>
            </div>
            <div className="modal-body">
              <div className="py-3 text-center">
                <i className="fas fa-lock ni-3x" />
                <h4 className="heading mt-4">Verifica la transferecia con el numero que se envio a tu celular.</h4>
                <form onSubmit={handleSubmit} role="form" class="">
                  <div class="code-group">
                    <div class="inputs-icons">
                    <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref1} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref2} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref3} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref4} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref5} />
                    <input type="text" class="form-control" placeholder="0" maxLength={1} ref={ref6} />
                    {//<input type="text" class="form-control" placeholder="0" maxLength={1} />
                    //<input type="text" class="form-control" placeholder="0" maxLength={1} />}
                    </div>
                  </div>
                  <div class="text-center">
                    <Button tipe="submit" style={{width:"50%"}} color="white" block size="lg" className="my-btn bg-primary text-white btn shadow btn-rounded mr-auto ml-auto">
                      Verificar Transacción
                      </Button>
                  </div>
                </form>
              </div>
            </div>
                  </Modal>
                */}
          <Modal
            className="modal-dialog-centered"
            style={{width:"400px",height:"200px"}}
            contentClassName=""
            isOpen={processModal}
            toggle={() => setProcessModal(!processModal)}
          >
            <div className="p-4">
              <div class="my-modal-header" style={{height:450 + 'px',lineHeight:0.5 +'px'}} ref={ref}>
                <img alt="delete-icon" class="my-header-brand-img" src={require("../../assets/img/brand/LogoIdea.png").default} />
                <img style={{height:"80px", width:"80px"}} alt="delete-icon" class="my-header-image" src={require("../../assets/img/illustrations/Success-transfer.png").default} />
                <div class="header-title">
                  <h4 class="avv-title-bold">Tu transferencia a la cuenta {productTwo.numeroCuenta} {productTwo.accountNumber} fue aprobada.</h4>
                  <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 0 + 'px',lineHeight:0.2 +'px',width:350+'px',height:230+'px' }}>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 0.8 }}>Valor</p>
                      <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 0.8 }}>Costo</p>
                      <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={commission} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 0.8 }}>Hacia</p>
                      <div style={{ textAlign: "right", margin: 0 }}>
                        <p style={{ margin: 0 }}>{productTwo.ownerAccount}</p>
                        {/*<p style={{ margin: 0 }}>Santander</p>*/}
                        <p style={{ margin: 0 }}> Ahorros No. {productTwo.numeroCuenta} {productTwo.accountNumber}</p>
                      </div>
                    </li>
                    <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 0" }}>
                      <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 0.8 }}>Desde</p>
                      <div style={{ textAlign: "right", margin: 0 }}>
                        <p style={{ margin: 0 }}>Ahorros No. {productOne.accountNumber}</p>
                        <p style={{ margin: 0 }}>Disponible <NumberFormat value={productOne.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="mt-3 pt-5">
                <button style={{width:"50%"}}class="my-btn btn bg-success text-white shadow btn-block ml-auto mr-auto mt-3" type="button" onClick={() => { setProcessModal(false); setTabs(0) }}> Continuar </button>
                {/* <Pdf targetRef={ref} filename="comprobante.pdf">
                  {({ toPdf }) => (
                    <button class="btn bg-gradient-white text-gray shadow btn-block btn-icon" type="button" onClick={toPdf}>
                      <span class="btn-inner--icon">
                        <i class="fas fa-download"></i>
                      </span>
                      <span class="btn-inner--text">Descargar comprobante</span>
                    </button>
                  )}
                </Pdf> */}

              </div>
            </div>
          </Modal>

          <div className="header pb-4 pt-5 pt-md-8">
            <Container fluid>
              <div className="header-body">
                <Nav
                  className="justify-content-center flex-column flex-md-row"
                  id="tabs-icons-text"
                  pills
                  role="tablist"
                >
                  <NavItem>
                    <NavLink
                      aria-selected={tabs === 1}
                      style={{"padding-top":0 +"rem",width:110 +'px',height:95 +'px'}}
                      className={classnames("card-body ml-2 mb-2 mb-xl-0 shadow", {
                        active: activeContact
                      })}
                      onClick={e => { if (step > 0 || step2 > 0) { 
                        setTabToGo(1);
                        dispatch(cambiaruta("Inicio/Transferencias/A Contactos Inscritos"))
                        setCancelationModal(true);
                        setActiveContact(true);
                        setActiveVertrans(false);
                        setImagen(icon_Contactos_InscritosA);
                        setColor("text-success");
                        setImagenTransferencias(icon_transferencias);
                        setColorTransferencias("text-gray-dark");
                        setImagenVerTransferencias(icon_VerTransferencias);
                        setColorVerTransferencias("text-gray-dark")} else { this.toggleNavs(e, "tabs", 1);setValue(""); }; }}
                      href="#contact"
                      role="tab"
                    >
                      <Row className="justify-content-center m-0">
                        <div className="icon icon-shape">
                          <img className="my-header-image mt-5" src={imagen} />
                        </div>
                      </Row>
                      <Row className={classnames("justify-content-center m-2",color)}>
                        <p className="mt-1 mb-0 pt-0 text-bold"
                              style={{
                                fontSize: 10 + "px",
                                width: 120 + "px",
                                textAlign: "center",
                                "line-height":1 +'em',
                                marginTop:2 +"px"}}>
                          A contactos inscritos
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem>

                  {/* <NavItem>
                    <NavLink
                      aria-selected={tabs === 2}
                      className={classnames("card-body ml-2 mb-2 mb-xl-0 shadow", {
                        active: tabs === 2
                      })}
                      onClick={e => { if (step > 0 || step2 > 0) { setTabToGo(2); setCancelationModal(true); } else { this.toggleNavs(e, "tabs", 2); }; }}
                      href="#internal"
                      role="tab"
                    >
                      <Row className="justify-content-center m-0">
                        <div className="icon icon-shape">
                          <img className="my-header-image mt-5" src={imagenTransferencias} />
                        </div>
                      </Row>
                      <Row className={classnames("justify-content-center m-2",colorTransferencias)}>
                        <p className="mt-3 mb-0 text-bold" style={{ fontSize: 13 + 'px', width: 101 + 'px', textAlign: "center", lineHeight: 1.43 }}>
                          Transferencias Internas
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem> */}

                  <NavItem>
                    <NavLink
                      aria-selected={tabs === 4}
                      style={{"padding-top":0 +"rem",width:110 +'px',height:95 +'px'}}
                      className={classnames("card-body ml-2 mb-2 mb-xl-0 shadow", {
                        active: activeVertrans
                      })}
                      onClick={e => { if (step > 0 || step2 > 0) {
                        dispatch(cambiaruta("Inicio/Transferencias/Ver Transferencias"))
                        setActiveVertrans(true);
                        setActiveContact(false);
                        setImagenVerTransferencias(icon_VerTransferenciasA);
                        setColorVerTransferencias("text-success");
                        setImagen(icon_Contactos_Inscritos);
                        setColor("text-gray-dark");
                        setImagenTransferencias(icon_transferencias);
                        setColorTransferencias("text-gray-dark");
                        setTabToGo(4); 
                        setCancelationModal(true);
                        getHistoricalTransfer();
                         } else { this.toggleNavs(e, "tabs", 4); getHistoricalTransfer(); }; }}
                      href="#historical"
                      role="tab"
                    >
                      <Row className="justify-content-center m-0">
                        <div className="icon icon-shape">
                          <img className="my-header-image mt-5" src={imagenVerTransferencias} />
                        </div>
                      </Row>
                      <Row className={classnames("justify-content-center m-2",colorVerTransferencias)}>
                        <p className="mt-1 mb-0 pt-0 text-bold"
                              style={{
                                fontSize: 10 + "px",
                                width: 105 + "px",
                                textAlign: "center",
                                "line-height":1.25 +'em',
                                marginTop:2 +"px"}}>
                          Ver transferencias
                        </p>
                      </Row>
                    </NavLink>
                  </NavItem>
                </Nav>
              </div>
            </Container>
          </div>
          <Container className="mb-4" key="container">
            <TabContent activeTab={"tabs" + tabs} key="tab-active">
              <TabPane tabId="tabs0">
                <Container fluid>
                  <div className="text-center m-4">
                    <h2 class="ml-2"> ¿Qué puedes hacer en transferencias de Santander? </h2>
                  </div>
                  <Row className="mt-5 ml-7 mr-7">
                    <Col xl="4" lg="4">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-user"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p ><span class="avv-title-semibold">Transfiere a tus contactos inscritos</span>{" "}hasta tu tope configurado.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xl="4" lg="4">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-exchange-alt"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p ><span class="avv-title-semibold">Transferencias internas</span>  a cuentas Santander.
                          </p>
                        </div>
                      </div>
                    </Col>
                    <Col xl="4" lg="4">
                      <div class="feature ng-star-inserted">
                        <div class="icon">
                          <span class="icon icon-usuario">
                            <i class="fas fa-list-ol"></i>
                          </span>
                        </div>
                        <div class="description">
                          <p ><span class="avv-title-semibold">Consulta las transferencias realizadas.</span> 
                          </p>
                        </div>
                      </div>
                    </Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs1" className="">
                <Container fluid>
                  <Row>
                    <Col xl="3" lg="2"></Col>
                    <Col xl="6" lg="8">
                      <DivStepper step={step} listStep={listStep} tab={1}>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Elige la cuenta de origen </h2>
                          </div>
                          <Products data={accounts} tab={1} isOrigin={true}></Products>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Ingrese el valor a transferir </h2>
                          </div>
                          <FormGroup>
                          <InputGroup className="input-group-alternative mt-2 mb-2">
                            <div className="inputs-icons-borderbott">
                              <Input
                                className="form-control h5 p-1"
                                placeholder="Valor a transferir"
                                type="text"
                                key={value}
                                autoComplete="new-value"
                                onChange={valueChange}
                                value={value}
                                autoFocus
                                style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}} />
                                <i className="fas fa-dollar-sign" />
                              </div>
                              <InputGroupAddon addonType="append">
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>
                          <div className="mt-3">
                            <button disabled={!value} onClick={() => getRelatedAccounts()} block size="lg" style={{width:"50%"}}className="my-btn bg-success text-white btn shadow btn-rounded btn-lg btn-block mr-auto ml-auto">
                              Continuar
                            </button>
                          </div>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Tus Cuentas </h2>
                          </div>
                          <Products data={accountsToTransfer} tab={1} isOrigin={false}></Products>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Elige una cuenta asociada </h2>
                          </div>
                          <RelatedAccounts data={relatedAccounts}></RelatedAccounts>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Vas a transferir </h2>
                          </div>
                          <div className="card p-4 m-4 shadow" style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                            <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={commission} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>{productTwo.ownerAccount}</p>
                                  {/*<p style={{ margin: 0 }}>Santander</p>*/}
                                  <p style={{ margin: 0 }}> Ahorros No. {productTwo.numeroCuenta} {productTwo.accountNumber}</p>
                                </div>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>Ahorros No. {productOne.accountNumber}</p>
                                  <p style={{ margin: 0 }}>Disponible <NumberFormat value={productOne.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <button onClick={() => transfer()} style={{width:"50%"}} className="my-btn bg-success text-white btn shadow btn-rounded btn-block btn-lg mt-5 mb-5 mr-auto ml-auto">
                            Transferir
                          </button>
                        </DivStep>
                      </DivStepper>
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs2" className="" key="tab-pane2">
                <Container fluid key="container-tab">
                  <Row key="row-step2">
                    <Col xl="3" lg="2"></Col>

                    <Col xl="6" lg="8">
                      <DivStepper step={step2} listStep={listStep2} tab={2} key="stepper2">
                        <DivStep>
                          <div className="text-center">
                            <h2 class="ml-2"> Elige la cuenta de origen </h2>
                          </div>
                          <Products data={accounts} tab={2} isOrigin={true}></Products>
                        </DivStep>
                        <DivStep>
                          <div className="text-center">
                            <h2 class="ml-2"> Ingrese el valor a transferir </h2>
                          </div>
                          <FormGroup>
                          <InputGroup className="input-group-alternative mt-2 mb-2">
                            <div className="inputs-icons-borderbott">
                              <Input
                                className="form-control h5 p-1"
                                placeholder="Valor a transferir"
                                type="text"
                                key={value}
                                autoComplete="new-value"
                                onChange={valueChange}
                                value={value}
                                autoFocus
                                style={{fontSize:"14px",border:"none", width:"250px",height:"25px",padding:"0px 0px 0px 0px",margin:"0px 0px 0px 0px"}} />
                                <i className="fas fa-dollar-sign" />
                              </div>
                              <InputGroupAddon addonType="append">
                              </InputGroupAddon>
                            </InputGroup>
                          </FormGroup>
                          <div className="mt-3">
                            <button disabled={!value} style={{width:"50%"}} onClick={() => setStep2(s => s + 1)} block size="lg" className="my-btn bg-green text-white btn shadow btn-rounded btn-lg btn-block mr-auto ml-auto">
                              Continuar
                            </button>
                          </div>
                        </DivStep>
                        <DivStep key="step-not-associated-account">
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Ingresa los datos de la cuenta </h2>
                          </div>
                          <Row>
                            <div className={classnames("radius-left shadow p-3 mt-4 mb-4 ml-6 text-center text-primary cursor-pointer col", {
                              active: types === 1
                            })} onClick={() => getTypeAccount(1)}>
                              Cuenta de Ahorros
                            </div>
                            <div className={classnames("radius-right shadow p-3 mt-4 mb-4 mr-6 mr-4 text-center text-primary cursor-pointer col", {
                              active: types === 2
                            })} onClick={() => getTypeAccount(2)}>
                              Cuenta Corriente
                            </div>
                          </Row>
                          <FormGroup key="form">
                            <InputGroup className="input-group-alternative mt-4 mb-4" key="group-accountNumber">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="far fa-credit-card" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                placeholder="Número de Cuenta"
                                type="text"
                                onChange={ProductTwoChange} />
                            </InputGroup>
                            <InputGroup className="input-group-alternative mb-4">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="far fa-list-alt" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <select onChange={TIDChange} class="selectpicker" placeholder="Tipo de Documento" className="form-control input-group-alternative">
                                <option value="1">Cédula de ciudadanía</option>
                                <option value="2">Tarjeta de Identidad</option>
                                <option value="3">Cédula de Extranjería</option>
                              </select>
                            </InputGroup>
                            <InputGroup className="input-group-alternative">
                              <InputGroupAddon addonType="prepend">
                                <InputGroupText>
                                  <i className="fas fa-id-card" />
                                </InputGroupText>
                              </InputGroupAddon>
                              <Input
                                placeholder="Documento de Identidad"
                                type="text"
                                onChange={NIDChange} />
                            </InputGroup>
                          </FormGroup>
                          <button onClick={() => BuildAccount()} className="my-btn bg-gradient-primary text-white btn shadow btn-rounded btn-block btn-lg">
                            Continuar
                          </button>
                        </DivStep>
                        <DivStep>
                          <div className="text-center m-4">
                            <h2 class="ml-2"> Vas a transferir </h2>
                          </div>
                          <div className="card p-4 m-4 shadow" style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                            <ul className style={{ listStyle: "none", padding: 0 + 'px', margin: 5 + 'px' }}>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Valor</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={value} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Costo</p>
                                <p style={{ textAlign: "right", margin: 0 }}><NumberFormat value={commission} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", borderBottom: "1px solid #acbac9", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Hacia</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>{productTwo.ownerAccount}</p>
                                  {/*<p style={{ margin: 0 }}>Santander</p>*/}
                                  <p style={{ margin: 0 }}> Ahorros No. {productTwo.accountNumber} </p>
                                </div>
                              </li>
                              <li style={{ display: "flex", justifyContent: "space-between", alignItems: "center", padding: "15px 0" }}>
                                <p style={{ fontWeight: 600, fontStyle: "normal", fontStretch: "normal", lineHeight: 1.08 }}>Desde</p>
                                <div style={{ textAlign: "right", margin: 0 }}>
                                  <p style={{ margin: 0 }}>Ahorros No. {productOne.accountNumber}</p>
                                  <p style={{ margin: 0 }}>Disponible <NumberFormat value={productOne.balance} displayType={'text'} thousandSeparator={true} prefix={'$'} /></p>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <button onClick={() => this.toggleModal("notificationModal")} className="my-btn bg-gradient-primary text-white btn shadow btn-rounded btn-block btn-lg mt-5 mb-4">
                            Transferir
                          </button>
                        </DivStep>
                      </DivStepper>
                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs3">
                <Container fluid>
                  <Row>
                    <Col xl="3" lg="2"></Col>
                    <Col xl="6" lg="8">

                    </Col>
                    <Col xl="3" lg="2"></Col>
                  </Row>
                </Container>
              </TabPane>
              <TabPane tabId="tabs4">
                <div className="col-md-12">
                  <HistoricalTransfers data={historicalTransfer}></HistoricalTransfers>
                </div>
              </TabPane>
            </TabContent>
          </Container>
        </>

      );
    }
  }

  return (
    <NavsTransfer></NavsTransfer>
  )
}

export default TransferHeader;
